import styled, { css } from 'styled-components'

interface ItemProps {
  padding?: string
  hasBorder?: boolean
  clickable?: boolean
  disabled?: boolean
}

export const Container = styled.div<{ bottomDistance?: number }>`
  ${({ bottomDistance }) => css`
    transform: translate(255px, calc(100% + 40px));
    position: fixed;
    bottom: ${bottomDistance ?? 40}px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid #e5eaeb;
    box-shadow: 0px 3px 8px rgba(0, 46, 62, 0.04);
    border-radius: 4px;
  `}
`
export const InnerContainer = styled.div`
  position: relative;
  padding: 16px 0;
  display: flex;
`

export const Item = styled.div<ItemProps>`
  ${({ padding, hasBorder, clickable, disabled, theme }) => css`
    &&& {
      display: flex;
      cursor: ${clickable && !disabled ? 'pointer' : 'initial'};
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      border-right: ${hasBorder ? '1px solid #e5eaeb' : 0};
      ${padding && `padding: ${padding};`}
      i::before {
        color: ${disabled ? `${theme.colors.abyss}80` : theme.colors.abyss};
      }
      svg path {
        fill: ${disabled ? '#08153A80' : '#08153A'};
      }
      i {
        margin: 0 0 5px 0 !important;
        cursor: inherit !important;
        height: 15px;
      }
    }
  `}
`
